import { Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { useCrudRecord } from '../../../containers/crud/recordContext';

export const WebsiteQueriesButton = () => {
  const { key } = useCrudRecord();
  return (
    <Tooltip title="Website Enquiries" placement="bottom">
      <Link
        className="ant-btn btn orange-btn-text"
        to={`website-enquiries/${key}`}
      >
        <QuestionCircleOutlined />
      </Link>
    </Tooltip>
  );
};
